module.exports = __webpack_public_path__ + "static/media/mem8.2a5af54e.jpg";